import api from './api'
import type { LabelOverridesPayload } from '@/types/labelOverrides.types'
import { loggerService, toLoggableError } from './logger.service'

/**
 * Fetch the tenant's label overrides (global defaults already merged by erp-api).
 * Returns null on failure so callers keep the shipped locale bundles.
 */
export async function fetchLabelOverrides(): Promise<LabelOverridesPayload | null> {
  try {
    const response = await api.get<LabelOverridesPayload>('/api/v1/meta/labels')
    return response.data
  } catch (err) {
    void loggerService.logError(toLoggableError(err), { action: 'meta_labels_fetch' })
    return null
  }
}
